module.exports = __webpack_public_path__ + "img/snkrhud-logo.abac20e8.png";